import { withInstall } from '@vuemap/vue-amap-util'
import Video from './Video.vue'

export const ElAmapLayerVideo = withInstall(Video)
export default ElAmapLayerVideo
